export default __webpack_public_path__ + "a204ea2cfbf7a12e76c20e4268ffec52.woff";